import colors from './colors';

const inputs = {
  radio: {
    default: {
      background: colors.ui01,
      border: colors.ui03,
      color: colors.text02,
    },
    hovered: {
      border: colors.brand03,
    },
    checked: {
      border: colors.brand03,
    },
    disabled: {
    },
    after: {
      background: colors.brand03,
    }
  },
  toggle: {
    default: {
      background: colors.ui03,
    },
    checked: {
      background: colors.brand03,
    },
    focused: {
      boxShadow: colors.brand03,
    },
  },
  checkbox: {
    default: {
      border: colors.ui03,
    },
    disabled: {
      background: colors.ui02,
      border: colors.ui03,
    },
    checked: {
      background: colors.brand03,
      border: colors.brand03,
    },
    error: {
      background: colors.errorRed,
      border: colors.errorRed
    },
    hover: {
      border: colors.brand03,
    }
  },
  input: {
    placeholder: {
      color: colors.text04,
    },
    default: {
      border: colors.ui03,
      background: colors.ui01,
      color: colors.text02
    },
    focus: {
      border: colors.text03,
      background: colors.ui01,
      color: colors.text02,
    },
    disabled: {
      border: colors.ui03,
      background: colors.ui01,
      color: colors.text03
    },
    error: {
      border: colors.errorRed,
      background: colors.ui01,
    }
  },
  dropdown: {
    default: {
      border: colors.ui03,
      background: colors.ui02,
      color: colors.text03
    },
    focus: {
      border: colors.text03,
      background: colors.ui01,
    },
    disabled: {
      border: colors.ui03,
      background: colors.ui01,
      color: colors.text04
    },
    error: {
      border: colors.errorRed,
      background: colors.ui01,
      color: colors.text03
    }
  }
};

export default inputs;
